<template>
  <a-modal
    :visible="visible"
    width="450px"
    :body-style="bodyStyle"
    centered
    :footer="null"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img
        class="image__inactive"
        src="@/app/users/assets/profiles/question-circle.png"
        alt="question"
      />
      <p class="text__alert">¿Estás seguro de inactivar a</p>
      <p class="text__alert">“{{ record.first_name }} {{ record.last_name }}”?</p>
    </div>
    <div class="container__info">
      <p class="text">Sucederán las siguientes acciones:</p>
      <ul>
        <li>Se desactivará de estrategias, colas y campañas a las que esté asociado.</li>
        <li>
          De tener tickets activos se reenviarán a su cola respectiva para que sean atendidos.
        </li>
        <li>
          Se quitara de la lista de usuarios y no se cobrará este usuario en la siguiente
          facturación.
        </li>
      </ul>
    </div>
    <a-form class="form" layout="vertical">
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-item class="form__item">
            <template #label>
              <span> Escribe la palabra <span class="strong">“Inactivar”</span> </span>
            </template>
            <a-input v-model:value="confirmText" placeholder="Escribe aquí..."></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="button__disabled">
      <a-button
        style="width: 100%"
        :disabled="confirmText !== 'Inactivar'"
        class="footer__next"
        type="primary"
        @click="handleCloseModal"
      >
        Inactivar cuenta
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";

export default defineComponent({
  name: "InactiveUserModal",
  components: {},
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const confirmText = ref("");
    const bodyStyle = {
      height: "515px",
      loading: false,
    };

    return {
      confirmText,
      bodyStyle,
    };
  },
  data() {
    return {
      UserStatus,
    };
  },
  methods: {
    handleCloseModal() {
      this.updateStatus();
      this.$emit("onCancel");
    },
    handleCloseModalHeader() {
      this.$emit("onCancel");
    },
    async updateStatus() {
      try {
        // let user = this.$store.getters['getUser']
        const body = {
          status: UserStatus.inactive,
        };
        await this.$store.dispatch("updateUser", {
          id: this.record.id,
          params: body,
        });
        this.$emit("update");
      } catch (error) {
        this.$message.error("El correo ya se encuentra registrado", 10);
      }
      this.$emit("onCloseModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  margin-top: 30px

.form
  overflow: hidden
  .title
    font-weight: 600
    font-size: 16px
    line-height: 24px
    color: $gray-9
p
  margin-bottom: 8px
.footer
  display: flex
  justify-content: flex-end
  position: absolute
  left: 0
  width: 100%
  height: 56px
  bottom: 0
  background: $white
  align-items: center
  border-top: 1px solid $gray-5
  border-radius: 0px 0px 4px 4px
  &__next
    margin-right: 1rem
  &__back
    margin-right: 1rem

.control__user
  margin-right: 530px
  & a
    margin-left: 10px

.disabledUser
  color: $gray-7

.deleteUser
  color: $red-6

:deep(.ant-calendar-picker)
  width: 188px

.flex
  display: flex
  justify-content: space-between

.profile
  text-align: center
  display: flex
  flex-direction: column

.line-yellow
  height: 10px
  background: $yellow-6
  width: 350px
  border-radius: 5px
  margin-top: 40px

.state
  margin-top: -30px
  margin-bottom: 30px
  text-align: initial

.container__profile
  margin-top: 8px
  margin-left: 70px

.info
  margin-bottom: 20px
  &--name
    font-size: 16px
    font-weight: 600

.container__inactive
  text-align: center
  color: $gray-13

.image__inactive
  margin-bottom: 10px
  margin-top: 10px

.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin: 0

.strong
  font-weight: 600

.container__info
  margin-bottom: 18px
  color: $gray-8

.text
  margin-top: 20px
  margin-bottom: 12px

.button__disabled
  margin-top: -2px
</style>
